import { createContext } from 'react';

import { HiveRenderingMetadataContextProps } from '../types/rendering.js';

export const HiveRenderingMetadataContext =
  createContext<HiveRenderingMetadataContextProps>({
    tileData: [],
    tilesCenters: [],
    renderMetadata: new WeakMap(),
  });

HiveRenderingMetadataContext['displayName'] = 'HiveRenderingMetadataContext';
